import React from 'react';
import { formatCurrencyAmount } from '../../utils/library';
import {
  HeaderWrapper,
  PageHeading,
  PointsCard,
  BalanceColumn,
  BalanceValue,
  BalanceLabelText,
  MonthSummaryColumn,
  MonthLabel,
  IpsEarnedText,
  IpsExpiringText,
  ViewBreakdownLink,
  BalanceValueOld,
  BalanceLabelTextOld
} from './styles';
import { Props } from './types';
import Modal from '../../components/modal/modal';
import IpsBreakdownModal from './IpsBreakdownModal';
import useUniformReferralEnabled from '../../hooks/useUniformReferralEnabled';

const InstaPointsHeader: React.FC<Props> = ({ headerTitle = true, ...props }) => {
  const [viewIpBreakdown, setViewIpBreakdown] = React.useState(false);
  const { isEnabled: isUniformReferralEnabled } = useUniformReferralEnabled();

  const ipBalance = props.ip_balance;
  const formattedIpBalance = ipBalance != null ? formatCurrencyAmount(ipBalance) : 0;
  const isNegativeBalance = (props.ip_balance ?? 0) < 0;

  return (
    <HeaderWrapper $headerTitle={headerTitle}>
      {headerTitle && <PageHeading>InstaPoints</PageHeading>}
      <PointsCard>
        <BalanceColumn>
          {isUniformReferralEnabled ? (
            <>
              <BalanceValue $isNegative={isNegativeBalance}>{formattedIpBalance} IPs</BalanceValue>

              <BalanceLabelText>
                {props.ip_redemption_value != null
                  ? `= SGD ${formatCurrencyAmount((ipBalance * props.ip_redemption_value).toFixed(2))}`
                  : ''}
              </BalanceLabelText>

              <ViewBreakdownLink
                text="View IPs breakdown"
                id="view-ips-breakdown"
                type="link"
                onClick={() => setViewIpBreakdown(true)}
              />
            </>
          ) : (
            <>
              <BalanceValueOld $isNegative={isNegativeBalance}>
                {formattedIpBalance}
              </BalanceValueOld>

              <BalanceLabelTextOld>Balance</BalanceLabelTextOld>
            </>
          )}
        </BalanceColumn>
        <MonthSummaryColumn>
          <MonthLabel>This month</MonthLabel>
          <IpsEarnedText>
            {props.ip_earned_current_month != null
              ? formatCurrencyAmount(props.ip_earned_current_month)
              : 0}{' '}
            IPs earned
          </IpsEarnedText>
          <IpsExpiringText>
            {props.ip_expired_current_month != null
              ? formatCurrencyAmount(props.ip_expired_current_month)
              : 0}{' '}
            IPs expiring
          </IpsExpiringText>
        </MonthSummaryColumn>
      </PointsCard>
      {viewIpBreakdown && (
        <Modal visible isPopup className="instapoint-modal-user-flow">
          <IpsBreakdownModal
            onClose={() => setViewIpBreakdown(false)}
            ip_balance={props.ip_balance}
            ip_balance_transactions={props.ip_balance_transactions}
            ip_balance_referral={props.ip_balance_referral}
          />
        </Modal>
      )}
    </HeaderWrapper>
  );
};

export default InstaPointsHeader;
